<template>
  <el-container class="home-container">
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <!-- 侧边栏菜单区域 -->
        <el-menu background-color="#212D3C" text-color="#fff" active-text-color="#56A1FF" unique-opened :collapse-transition="false" router :default-active="activePath" :collapse="isCollapse">
          <!-- 一级菜单 -->
          <el-submenu :index="item.id + ''" v-for="(item,index) in menulist" :key="index">
            <template slot="title" class="el-submenu-title">
              <!-- 图标 -->
              <i :class="iconsObj[item.id]"></i>
              <span>{{item.authName}}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.path" v-for="(subItem,index) in item.children" :key="index" @click="saveNavState('/' + subItem.path)">
              <template slot="title">
                <!-- 图标 -->
                <span class="subItem-title">{{subItem.authName}}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 右侧内容主体 -->
      <el-container>
        <el-header>
          <div>
            <i class="elIocn el-icon-s-fold" @click="toggleCollapse"></i>
            <i class="elIocn el-icon-s-unfold" @click="toggleCollapse"></i>
            <div class="example-container">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="(item,index) in breadList" :key="index">
                  <router-link :to="item.path"></router-link>
                  {{item.meta.title}}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="headerright">
            <div style="margin-right: 25px;margin-bottom: -10px" @click="reload">
              <i class="el-icon-refresh"></i>
              <p>刷新页面</p>
            </div>
            <div style="margin-bottom: -10px">
              <i class="el-icon-s-home"></i>
              <p><router-link to="/console">控制台</router-link></p>
            </div>
            <div>
              <el-avatar style="width: 55px;height: 55px;margin-left: 30px;margin-right: 18px" shape="square" size="medium" :src="squareUrl"></el-avatar>
            </div>
            <div class="fonttitle">
              <p>部门</p>
              <p style="font-size: 18px">姓名</p>
            </div>
            <div @click="logout" class="logout">退出</div>
          </div>
        </el-header>
        <tags-view></tags-view>
        <el-main>
          <!-- 路由占位符 -->
          <keep-alive :include="cachedViews">
            <router-view :key="key" />
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import TagsView from '../components/TagsView/index.vue'

export default {

  inject: ['reload'],
  components: {
    TagsView
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  data() {
    return {
      // 左侧菜单数据
      menulist: [{
        authName: '全局设置',
        id: 1,
        order: 1,
        path: 'console',
        children: [{
          id: 11,
          authName: '控制台',
          path: 'console',
          children: [],
          order: null
        }]
      },
      {
        authName: '用户名片列表',
        id: 2,
        order: 2,
        path: 'user',
        children: [{
          id: 21,
          authName: '用户列表',
          path: 'users',
          children: [],
          order: null
        },
        {
          id: 22,
          authName: '名片列表',
          path: 'card',
          children: [],
          order: null
        },
        {
          id: 23,
          authName: '教育培训列表',
          path: 'educationTraining',
          children: [],
          order: null
        },
        {
          id: 24,
          authName: '工作经历列表',
          path: 'workExperience',
          children: [],
          order: null
        }
        ]
      },
      {
        authName: '名片配置管理',
        id: 3,
        order: 3,
        path: 'cardTheme',
        children: [{
          id: 31,
          authName: '名片主题',
          path: 'cardTheme',
          children: [],
          order: null
        },
        {
          id: 32,
          authName: '消息提示',
          path: 'infoHint',
          children: [],
          order: null
        }
        ]

      },
      {
        authName: '权限管理',
        id: 4,
        order: 4,
        path: 'adminers',
        children: [{
          id: 41,
          authName: '管理员列表',
          path: 'adminers',
          children: [],
          order: null
        },
        {
          id: 42,
          authName: '部门组列表',
          path: 'groups',
          children: [],
          order: null
        },
        {
          id: 43,
          authName: '权限列表',
          path: 'rules',
          children: [],
          order: null
        }
        ]
      }
      ],
      iconsObj: {
        '1': 'elIocn el-icon-s-home',
        '2': 'elIocn el-icon-s-custom',
        '3': 'elIocn el-icon-bank-card',
        '4': 'iconfont icon-tijikongjian '
      },
      // 是否折叠
      isCollapse: false,
      // 被激活的链接地址
      activePath: '0',
      squareUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
    }
  },
  created() {
    this.getBreadcrumb()
    this.activePath = window.sessionStorage.getItem('activePath')
    if (!this.activePath) {
      this.activePath = '/console'
    }
    console.log('  this.activePath ', this.activePath)
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      // console.log('matched',matched)
      this.breadList = matched
    },
    logout() {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    // 保存链接的激活状态
    saveNavState(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    }
  }
}
</script>

<style lang="less">
  .home-container {
    height: 100%;
  }

  .el-header {
    background-color: #fff;
    border-bottom: 1px solid #F0F0F0;
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    align-items: center;
    color: #fff;
    font-size: 20px;
    height: 80px !important;

    >div {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-right: 25px;
      margin-bottom: -10px;

      span {
        font-weight: normal;
        color: #999999;
      }
    }

    .elIocn {
      color: #333333;
      font-size: 30px;
      margin-left: 10px;
    }

    .el-breadcrumb__inner.is-link {
      font-weight: normal !important;
      color: #333333;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #999999;
    }

    .el-breadcrumb__separator {
      margin-left: 3px;
    }

    .fonttitle {
      p {
        font-size: 24px;
        color: #999999;
        height: 5px;
        text-align: left;
      }
    }

    .logout {
      margin-top: 30px;
      margin-left: 15px;
      font-size: 18px;
      color: #569EF8;

    }
  }

  .el-aside {
    background-color: #334154;

    .el-menu {
      border-right: none;
      font-size: 16px !important;

      .el-submenu {
        background-color: #334154;
        font-size: 16px !important;

        .el-submenu__title {
          background-color: #334154 !important;
          font-size: 16px !important;
          color: #C2CCD9 !important;
        }

        .subItem-title {
          font-size: 16px;
          color: #C2CCD9;
        }

        .el-menu-item.is-active .subItem-title {
          color: #409EFF !important;
        }

        .elIocn {
          margin-right: 10px;
          color: #C2CCD9 !important;
          font-size: 20px;
        }
      }

    }
  }

  .headerright {
    text-align: center;

    i {
      color: #999999;
      font-size: 30px;
    }

    p {
      color: #999999;
      font-size: 18px;
      line-height: 0px;

      a {
        color: #999999;
        text-decoration: none;
      }
    }

  }

  .iconfont {
    margin-right: 10px;
    color: #C2CCD9 !important;
    font-size: 20px;
  }

  .toggle-button {
    background-color: #4a5064;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
  }
</style>
